/******/ (() => { // webpackBootstrap
class CartRecommendations extends HTMLElement {
  constructor() {
    super();
    this.recommendationsDrawer = this.closest('[data-cart-drawer-recommendations]');
    this.fetchRecommendations = this.fetchRecommendations.bind(this);
    this.handleDrawerOpened = this.handleDrawerOpened.bind(this);
    this.renderRecommendations = this.renderRecommendations.bind(this);
    this.hasFetched = false;
    this.isFetching = false;
  }

  connectedCallback() {
    window.wetheme.webcomponentRegistry.register({key: 'component-cart-recommendations'});
    window.eventBus.on('drawer:opened', this.handleDrawerOpened);

    if (this.closest('cart-drawer')?.getAttribute('aria-hidden') === 'false') {
      this.fetchRecommendations();
    }
  }

  handleDrawerOpened(drawer) {
    if (drawer === this.closest('cart-drawer')) {
      this.fetchRecommendations();
    }
  }

  async fetchRecommendations() {
    if (!this.url || this.hasFetched || this.isFetching) return;

    this.isFetching = true;
 
    try {
      const response = await fetch(this.url);
      
      if (response.ok) {
        const responseText = await response.text();
        this.renderRecommendations(responseText);
        this.hasFetched = true;
      }
    } catch (error) {
      console.error(`Failed to fetch cart drawer:`, error);
    } finally {
      this.isFetching = false;
    }
  }

  renderRecommendations(html) {
    const updatedContent = new DOMParser().parseFromString(html, 'text/html').querySelector('cart-recommendations')?.innerHTML;
    
    if (!updatedContent || updatedContent.trim().length === 0) {
      /* ===== If no recommendations, hide the secondary drawer ===== */
      this.closest('cart-drawer')?.classList.add('hide-recommendations');
    } else {
      /* ===== If recommendations, update content ===== */
      this.innerHTML = updatedContent;
      this.closest('cart-drawer')?.classList.remove('hide-recommendations');

      /* ===== Prevent mobile content shift with each fetch by fixing the parent height and re-calculating after each fetch ===== */
      if (window.matchMedia('only screen and (max-width: 767px)').matches) {
        this.parentElement.style.height = 'auto';
        this.parentHeight = this.parentElement.getBoundingClientRect().height;
        this.parentElement.style.height = '';
        document.documentElement.style.setProperty('--cart-recommendations-height', `${this.parentHeight}px`);
      }
    }
  }

  get url() {
    return this.getAttribute('data-cart-recommendations-url');
  }
}

customElements.define('cart-recommendations', CartRecommendations);
/******/ })()
;
